/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const FirstDayOfWeekFromLocaleSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('FIRST_DAY_OF_WEEK_FROM_LOCALE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class FirstDayOfWeekFromLocaleSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FirstDayOfWeekFromLocaleSettingParser.decode(input).map(res => new FirstDayOfWeekFromLocaleSetting(res));
    }
    static unsafeDecode(input) {
        return FirstDayOfWeekFromLocaleSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FirstDayOfWeekFromLocaleSettingParser.encode(data);
    }
    static schema() {
        return FirstDayOfWeekFromLocaleSettingParser.schema();
    }
}
